// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.block_fZ0yQ {
  position : absolute;
  display : inline-block;  
  top : var( --size-linearViewBlockTop, 8px );
  bottom : var( --size-linearViewBlockBottom, 8px );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/Block.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;EAC3C,iDAAiD;AACnD","sourcesContent":["\n.block {\n  position : absolute;\n  display : inline-block;  \n  top : var( --size-linearViewBlockTop, 8px );\n  bottom : var( --size-linearViewBlockBottom, 8px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `block_fZ0yQ`
};
export default ___CSS_LOADER_EXPORT___;
